<template>
  <div class="w-full lg:w-1/3 sm:w-1/2 sm:p-2 p-4 my-2 cursor-pointer">
    <div class="rounded overflow-hidden shadow-lg w-full">
      <img
        @click="navigate(course.id)"
        class="w-full h-48 object-cover cursor-pointer"
        :src="course.course_image"
        alt="Sunset in the mountains"
      />
      <div class="px-6 py-4">
        <div class="program-main mb-2 tenant-main-color">
          {{ course.title }}
        </div>
        <p class="program-content text-gray-700 text-base">
          {{ course.caption }}
        </p>
        <div
          class=" program-content flex flex-wrap tenant-main-color my-2 justify-between"
        >
          <span class="cursor-pointer" @click="playVideo"
            >Watch Overview Video</span
          >
          <div></div>
        </div>
        <div class="flex justify-between flex-wrap">
          <lms-button v-if="!courseInCart && course.payment_type !== 'free'" @click="addToCart" class="my-1"
          >Enroll</lms-button
          >
          <lms-button v-if="!courseInCart && course.payment_type == 'free'" @click="addToCart" class="my-1"
          >Enroll Free</lms-button
          >
          <lms-button
                  v-if="courseInCart"
                  @click="$router.push({ name: 'learner-cart' })"
                  style="background: green"
          >View in Cart</lms-button
          >
          <lms-outline-button
            @click="addToWishList"
            class="my-2"
            v-if="!courseInWishList"
            :color="this.colorTheme"
          >
            <i class="far fa-heart"></i> Wishlist</lms-outline-button
          >
          <lms-button v-else @click="removeFromWishlist">Remove</lms-button>
        </div>
      </div>
    </div>

    <modal @click="hide" :name="'overview-video'+course.id">
      <Media
        kind="video"
        :controls="true"
        :src="course.course_video"
        :style="{ width: '100%' }"
      >
      </Media>
    </modal>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
import { mapActions, mapGetters } from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";
export default {
  props: {
    course: {},
  },
  data() {
    return {
      paidCourses: this.$store.state.learner.courses,
      courseCart: [],
      wishlistData: [],
    };
  },
  mixins: [SettingsMixin],
  components: {
    LmsButton: () => import("@/components/general/button"),
    LmsOutlineButton: () => import("@/components/general/outline_button"),
    Media,
  },
  methods: {
    ...mapActions([
      "learnerAddToCart",
      "fetchCourseLessons",
      "learnerAddToWish",
    ]),
    navigate(id) {
      this.$router.push({ name: "single-external-course", params: { id: id } });
    },
    playVideo() {
      this.$modal.show("overview-video" + this.course.id);
    },
    async addToCart() {
      if (localStorage.getItem("lms_cart")) {
        this.courseCart = [
          ...JSON.parse(localStorage.getItem("lms_cart")),
          this.course.id,
        ];
      } else {
        this.courseCart = [this.course.id];
      }

      localStorage.setItem("lms_cart", JSON.stringify(this.courseCart));
      this.$Bus.$emit("cartUpdated", this.courseCart);
    },
    async removeFromCart() {
      let data = this.courseCart.filter((value) => {
        return value !== this.course.id;
      });
      localStorage.setItem("lms_cart", JSON.stringify(data));
      this.courseCart = data;
      this.$Bus.$emit("cartUpdated", this.courseCart);
    },
    async addToWishList() {
      if (localStorage.getItem("lms_wishlist")) {
        this.wishlistData = [
          ...JSON.parse(localStorage.getItem("lms_wishlist")),
          this.course.id,
        ];
      } else {
        this.wishlistData = [this.course.id];
      }
      localStorage.setItem("lms_wishlist", JSON.stringify(this.wishlistData));
    },
    async removeFromWishlist() {
      let data = this.wishlistData.filter((value) => {
        return value !== this.course.id;
      });
      localStorage.setItem("lms_wishlist", JSON.stringify(data));
      this.wishlistData = data;
    },
    hide() {
      this.$modal.hide("overview-video"+this.course.id);
    },
  },
  mounted() {
    let temp = localStorage.getItem("lms_cart");
    if (temp) {
      this.courseCart = JSON.parse(temp);
    }
    let wishlist = localStorage.getItem("lms_wishlist");
    if (wishlist) {
      this.wishlistData = JSON.parse(wishlist);
    }
  },

  computed: {
    ...mapGetters({
      cart: "getLearnerCart",
      wishlist: "getLearnerWish",
    }),
    courseInCart() {
      return Object.values(this.courseCart).includes(this.course.id);
    },
    courseInWishList() {
      return Object.values(this.wishlistData).includes(this.course.id);
    },
  },
};
</script>

<style lang="css" scoped>
.program-main {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.program-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}
</style>
